import Language from '../entity/Language';
import { useGetInsightCategoriesQuery } from '../generated/graphql';

export const useGetInsightCategories = ({
  language,
  organizationId,
}: {
  language: Language;
  organizationId?: string;
}) => {
  const { data, loading, error } = useGetInsightCategoriesQuery({
    variables: { language, organizationId },
  });

  return { insightCategories: data?.insightCategoriesByOrganization, loading, error };
};
